import { TemplateInterface } from "@/interfaces/template.interface";
import axios from "@/libs/axios";
import { RequestQueryBuilder } from "@rewiko/crud-request";
//import { useQuery } from "@tanstack/vue-query";
//import { AxiosResponse } from "axios";
import { defineStore } from "pinia";

interface State {
    templates: TemplateInterface[];
    isLoadingTemplates: boolean;
}

export const useTemplatesStore = defineStore("templates", {
    state: (): State => ({
        templates: [],
        isLoadingTemplates: false,
    }),
    actions: {
        async fetchTemplates(requestQueryBuilder?: RequestQueryBuilder): Promise<void> {
            // @NOTE function is called in a watch, so anonymous function scope what result in issues with vue-query.

            this.isLoadingTemplates = true;

            const { data } = await axios.get<TemplateInterface[]>(`${process.env.VUE_APP_PUBLIC_API}/templates`, {
                params: requestQueryBuilder?.queryObject,
            });

            this.templates = data;
            this.isLoadingTemplates = false;

            //useQuery<Pick<AxiosResponse<TemplateInterface[]>, "data">>(
            //    ["templates", requestQueryBuilder?.queryObject],
            //    () => {
            //        this.isLoadingTemplates = true;
            //        return axios.get<TemplateInterface[]>(`${process.env.VUE_APP_PUBLIC_API}/templates`, {
            //            params: requestQueryBuilder?.queryObject,
            //        });
            //    },
            //    {
            //        //staleTime: 3000, // Gave some issues, so commented
            //        placeholderData: { data: [] },
            //        onSuccess: (response) => (this.templates = response.data),
            //        onSettled: () => (this.isLoadingTemplates = false),
            //    }
            //);
        },
    },
    getters: {
        textTemplates(state) {
            return state.templates.filter((template) => {
                return !(
                    template.mediaType ||
                    template.components?.buttons?.buttons.some((button) => "dynamic" in button && button.dynamic)
                );
            });
        },
        mediaTemplates(state) {
            return state.templates.filter((template) => {
                return !(
                    !template.mediaType ||
                    template.components?.buttons?.buttons.some((button) => "dynamic" in button && button.dynamic)
                );
            });
        },
    },
});
